import { render, staticRenderFns } from "./AttachmentsList.vue?vue&type=template&id=16680d00"
import script from "./AttachmentsList.vue?vue&type=script&lang=js"
export * from "./AttachmentsList.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsList.vue?vue&type=style&index=0&id=16680d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports